import axios from "axios";

export interface AssignPickupRequestParams {
  requestNumber: string;
  portalUserId: number;
}

export const assignToPortalUser = ({
  requestNumber,
  portalUserId,
}: AssignPickupRequestParams): Promise<void> =>
  axios
    .post(`pickupRequests/${requestNumber}/assignToPortalUser`, {
      portalUserId,
    })
    .then(() => undefined);

export default assignToPortalUser;
